<template>
  <div class="campaign-performance">
    <div class="py-4">
      <div class="row g-4">
        <!-- Total Reach -->
        <div class="col-md-3">
          <div class="card p-3">
            <h6 class="text-muted text-center">TOTAL REACH</h6>
            <h2 class="fw-bold text-center">25,600</h2>
            <div class="small text-secondary m-auto">
              <div class="d-flex justify-content-between">
                EMAIL <span class="pl-3">17,000</span>
              </div>
              <div class="d-flex justify-content-between">
                SOCIAL MEDIA <span class="pl-3">8,600</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Total Clicks -->
        <div class="col-md-3">
          <div class="card p-3">
            <h6 class="text-muted text-center">TOTAL CLICKS</h6>
            <h2 class="fw-bold text-center">24,510</h2>
          </div>
        </div>

        <!-- Applications Started -->
        <div class="col-md-3">
          <div class="card p-3">
            <h6 class="text-muted text-center">TOTAL APPLICATIONS STARTED</h6>
            <h2 class="fw-bold text-center">6,200</h2>
          </div>
        </div>

        <!-- Applications Completed -->
        <div class="col-md-3">
          <div class="card p-3">
            <h6 class="text-muted text-center">TOTAL APPLICATIONS COMPLETED</h6>
            <h2 class="fw-bold text-center">3,950</h2>
          </div>
        </div>
      </div>

      <div class="row g-4 mt-1">
        <!-- Funnel -->
        <div class="col-md-3">
          <div class="card p-3">
            <FunnelChart
              :data="funnelChartData"
              :height="'450px'"
              :keys="['Stage', 'Count']"
            />
          </div>
        </div>

        <div class="col-md-6">
          <!-- Performance Chart -->
          <div class="card p-3">
            <h6 class="text-muted mb-2 text-uppercase">Campaign Performance Over Time</h6>
            <div>
              <BasicLine
                :data="campaignPerformanceData"
                :options="options"
                :height="150"
              />
            </div>
          </div>
          <!-- Contribution -->
          <div class="card p-3">
            <h6 class="text-muted mb-2 text-uppercase">Campaign Contribution</h6>
            <div class="text-center">
              <BasicPie
                :data="campaignContributionData"
                :options="pieOptions"
                :showLegend="false"
              />
            </div>
          </div>
        </div>

        <!-- Conversion + Cost -->
        <div class="col-md-3">
          <div class="card p-3 mb-3">
            <h6 class="text-muted">CONVERSION RATE</h6>
            <h3 class="fw-bold text-primary">16.1%</h3>
          </div>
          <div class="card p-3">
            <h6 class="text-muted">COST PER APPLICATION</h6>
            <h3 class="fw-bold text-primary">$22.75</h3>
          </div>
          <div class="card p-3 donut-chart m-auto text-center">
            <h6 class="text-muted mb-2 text-uppercase">Budget Utilization(%)</h6>
            <div class="d-flex m-auto">
              <CChartDoughnut
                :datasets="defaultDatasets"
                :labels="labels"
                :options="{
                  responsive: true,
                  cutout: '70%',
                  plugins: {
                    legend: {
                      position: 'bottom',
                    },
                    tooltip: {
                      enabled: true,
                    },
                  },
                  legend: {
                    display: false,
                  },
                }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BasicLine from "@/components/reusable/Charts/BasicLine.vue";
import FunnelChart from "@/components/reusable/Charts/Apex/FunnelChart.vue";
import BasicPie from "@/components/reusable/Charts/BasicPie.vue";
import { CChartDoughnut } from "@coreui/vue-chartjs";
export default {
  name: "campaignPerformance",
  components: {
    BasicLine,
    FunnelChart,
    BasicPie,
    CChartDoughnut,
  },
  data() {
    return {
      campaignPerformanceData: [
        {
          name: "Total Reach",
          borderColor: "#5478AF",
          backgroundColor: "#5478AF",
          type: "line",
          tension: 0.4,
          fill: false,
          values: [
            { name: "May 25", value: 500 },
            { name: "Jun 25", value: 600 },
            { name: "Jul 25", value: 750 },
            { name: "Aug 25", value: 550 },
            { name: "Sep 25", value: 900 },
            { name: "Oct 25", value: 1000 },
          ],
        },
      ],
      funnelChartData: [
        {
          name: "Total Reach",
          value: 500,
        },
        {
          name: "Total Clicks",
          value: 400,
        },
        {
          name: "Total Applications Started",
          value: 350,
        },
        {
          name: "Total Applications Completed",
          value: 250,
        },
      ],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        animation: {
          duration: 0,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                display: true,
                fontStyle: "bold",
                stepSize: 200,
              },
              scaleLabel: {
                display: true,
                fontStyle: "bold",
              },
              gridLines: {
                display: true,
              },
              title: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                display: true,
                beginAtZero: true,
                fontStyle: "bold",
              },
              scaleLabel: {
                display: true,
                fontStyle: "bold",
              },
              gridLines: {
                display: true,
              },
              title: {
                display: false,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            color: "#fff",
            anchor: "end",
            align: "start",
            font: {
              weight: "bold",
              size: 12,
            },
            formatter: (value) => value,
          },
        },
      },
      campaignContributionData: [
        {
          name: "Self",
          value: 15000,
          backgroundColor: "#4971AB",
        },
        {
          name: "Sourced",
          value: 11000,
          backgroundColor: "#25436D",
        },
      ],
      pieOptions: {
        maintainAspectRatio: false,
        animation: {
          duration: 0, // Disable all animations
        },
        legend: {
          display: false,
        },
      },
      defaultDatasets: [
        {
          backgroundColor: ["#25436D", "#4971AB"],
          data: [40, 60],
          label: "Total Reach",
          hoverOffset: 10,
        },
      ],
      labels: ["Consumed", "Remaining"],
    };
  },
};
</script>
<style scoped>
.card {
  border: none;
  border-radius: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.funnel {
  background: linear-gradient(to bottom, #1e3a8a, #2563eb);
  border-radius: 16px;
  color: #ffffff;
  text-align: center;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
  min-height: 400px;
}

.funnel-step {
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.4);
  margin: 0.5rem 0;
}
.chart-container {
  height: 200px;
}
.donut-chart {
  height: 250px;
}
</style>
